var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_6774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 7.33301H0.666667C0.298477 7.33301 0 7.63149 0 7.99968C0 8.36787 0.298477 8.66635 0.666667 8.66635H15.3333C15.7015 8.66635 16 8.36787 16 7.99968C16 7.63149 15.7015 7.33301 15.3333 7.33301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 2.66699H0.666667C0.298477 2.66699 0 2.96547 0 3.33366C0 3.70185 0.298477 4.00032 0.666667 4.00032H15.3333C15.7015 4.00032 16 3.70185 16 3.33366C16 2.96547 15.7015 2.66699 15.3333 2.66699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 12H0.666667C0.298477 12 0 12.2985 0 12.6667C0 13.0349 0.298477 13.3333 0.666667 13.3333H15.3333C15.7015 13.3333 16 13.0349 16 12.6667C16 12.2985 15.7015 12 15.3333 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_6774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.a6946be1a1b074f3904aef753e635255.svg";
export { ForwardRef as ReactComponent };